import React from "react";
import Style from "../../OrderListAll/ProductInfoAll/ProductInfoAll.module.scss";
const ProductInfoAllPeyk = ({ data}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {data.products.map((element) => {
        return (
          <div key={element.order_id} className={Style.orderInfo}>
            <p className={Style.food}>{element.want_name}</p>
            <p className={Style.count}>{element.count} عدد</p>
          </div>
        );
      })}
    </div>
  );
};

export default ProductInfoAllPeyk;
